// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__24cX_","footer":"ModalUpdate_footer__19qXX"};